// extracted by mini-css-extract-plugin
export var path = "Hamburger-module--path--2d148";
export var root = "Hamburger-module--root--1457e";
export var svg = "Hamburger-module--svg--d3402";